function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const ProjectsSchemaIcon = (_0)=>{
    let { color = '#424960' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_height;
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 40,
        height: (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : 40,
        viewBox: "0 0 40 40",
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M35.1522 24.5456H32.1219V20.0002C32.1219 19.5983 31.9622 19.2129 31.6781 18.9288C31.3939 18.6446 31.0086 18.485 30.6067 18.485H21.5158V15.4547H24.5461C24.948 15.4547 25.3333 15.2951 25.6175 15.0109C25.9016 14.7268 26.0613 14.3414 26.0613 13.9396V4.84865C26.0613 4.4468 25.9016 4.06142 25.6175 3.77727C25.3333 3.49313 24.948 3.3335 24.5461 3.3335H15.4552C15.0534 3.3335 14.668 3.49313 14.3838 3.77727C14.0997 4.06142 13.94 4.4468 13.94 4.84865V13.9396C13.94 14.3414 14.0997 14.7268 14.3838 15.0109C14.668 15.2951 15.0534 15.4547 15.4552 15.4547H18.4855V18.485H9.39459C8.99275 18.485 8.60736 18.6446 8.32322 18.9288C8.03907 19.2129 7.87944 19.5983 7.87944 20.0002V24.5456H4.84914C4.44729 24.5456 4.06191 24.7052 3.77776 24.9894C3.49362 25.2735 3.33398 25.6589 3.33398 26.0608V35.1517C3.33398 35.5535 3.49362 35.9389 3.77776 36.2231C4.06191 36.5072 4.44729 36.6668 4.84914 36.6668H13.94C14.3419 36.6668 14.7273 36.5072 15.0114 36.2231C15.2956 35.9389 15.4552 35.5535 15.4552 35.1517V26.0608C15.4552 25.6589 15.2956 25.2735 15.0114 24.9894C14.7273 24.7052 14.3419 24.5456 13.94 24.5456H10.9097V21.5153H29.0916V24.5456H26.0613C25.6594 24.5456 25.274 24.7052 24.9899 24.9894C24.7057 25.2735 24.5461 25.6589 24.5461 26.0608V35.1517C24.5461 35.5535 24.7057 35.9389 24.9899 36.2231C25.274 36.5072 25.6594 36.6668 26.0613 36.6668H35.1522C35.554 36.6668 35.9394 36.5072 36.2235 36.2231C36.5077 35.9389 36.6673 35.5535 36.6673 35.1517V26.0608C36.6673 25.6589 36.5077 25.2735 36.2235 24.9894C35.9394 24.7052 35.554 24.5456 35.1522 24.5456ZM12.4249 27.5759V33.6365H6.36429V27.5759H12.4249ZM16.9703 12.4244V6.3638H23.031V12.4244H16.9703ZM33.637 33.6365H27.5764V27.5759H33.637V33.6365Z",
            fill: color
        })
    });
};
